import React from 'react';

const ComponentIfNotNull = ({component:Component='div', children=null, nullComponent:NullComponent=null, ...props}) => (
  children
    ? <Component {...props}>{children}</Component>
    : <NullComponent />
);

export default ComponentIfNotNull;
